import { RestClient } from '../lib/RestClient'

class CardapioService extends RestClient {
  constructor() {
    super('cardapio')
  }

  async getTipos(params = {}) {
    const tipos = await this.request.get('tipo', {
      params
    })
    return tipos.data
  }
  async deletarItem(id, params = {}) {
    await this.request.delete(`item/${id}`, {
      params
    })
  }

  async addItem(item, params = {}) {
    await this.request.post('item', item, {
      params
    })
  }
  async desativarPorID(id, selectedEscola) {
    const response = await this.request.put(`desativar/${id}`, {
      escola: selectedEscola
    })
    return response.data
  }

  async desativar(id, statusDesativado, selectedEscola) {
    const response = await this.request.put(
      `status/${id}/${statusDesativado}`,
      {
        escola: selectedEscola
      }
    )
    return response.data
  }

  enviar(id, turma, params = {}) {
    return this.request({
      method: 'post',
      url: `enviar/${id}`,
      data: {
        turma
      },
      params
    })
  }

  async agendar(agenda, params = {}) {
    const response = await this.request.post('/agendar', agenda, {
      params
    })
    return response.data
  }

  async findByIdProduto(id, params = {}) {
    const response = await this.request.get(`produto/${id}`, { params })
    return response.data
  }
}

export const Cardapio = new CardapioService()
